
import { namespace } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";
const app = namespace("app");
@Component({})
export default class Template extends Vue {
  @app.State autoPopOpTemplate;
  @app.Mutation setAutoPopOpTemplate;
  handleChange(val) {
    this.setAutoPopOpTemplate(!val);
  }
}
